/**
 * This custom function is usefull for programattic display
 * of images. Especially useful when you only wish to load images
 * to the page when required. A use case for this plugin would be
 * on the Cart Page. Since we always load a rug pad carousel to the
 * DOM, and oftentimes it will remain hidden, we don't want to load
 * the images everytime.
 * 
 * doLoad allows passing of any class. The element should have the following
 * data-lazy-swap-imgs="<mediumURL>|<largeURL>" data-lazy-swap-alt="<alt>"
 * and of course a class to identify when initializing.
 */
custom.lazySwap = (() => {

    const render = ({medium,large,alt}) => `<img src="${medium}" srcset="${large} 2x" alt="${alt}">`;

    function doLoad(lazySwapClass=null) {
        if(!lazySwapClass || !$(lazySwapClass).length) return;
        $(lazySwapClass).each(function() {
            const imgObject = {};
            const images = $(this).data('lazy-swap-imgs');
            const alt = $(this).data('lazy-swap-alt');
            if(images) {
                const imagesArray = images.split('|');
                imgObject.medium = imagesArray[0];
                imgObject.large = (imagesArray[1]) ? imagesArray[1] : imagesArray[0];
                imgObject.alt = alt;
            }
            $(this).append(render(imgObject));
        });
    }

    return {
        doLoad
    }
})();


// WEBPACK FOOTER //
// ./src/scripts/src/custom/lazy-swap.js